<template>
  <BaseModal
    :heading="$t('register.sale.cannot_save_outstanding')"
    small
    @close="emits('close')"
    testId="cannot-save-outstanding"
  >
    <BaseText>{{ $t('register.sale.cannot_save_outstanding_info') }}</BaseText>
    <template #footer>
      <BaseButton
        color="inverted"
        @click="emits('close')"
      >
        {{ $t('global.actions.cancel') }}
      </BaseButton>
      <BaseButton
        :routerLink="{ name: 'sale', params: { id: String(orderId) } }"
        @click="emits('close')"
        v-test="'view-sale'"
      >
        {{ $t('global.actions.view_sale') }}
      </BaseButton>
    </template>
  </BaseModal>
</template>

<script
  lang="ts"
  setup
>
defineProps<{
  orderId: number;
}>();

const emits = defineEmits(['close']);
</script>
